export interface ITheme {
  palette: {
    background: string
    text: string
    valid: string
    error: string
    warning: string
  }
}

export const theme: ITheme = {
  palette: {
    background: '#000000',
    text: '#ffffff',
    valid: '#269e50',
    error: '#fd5859',
    warning: '#ebba34',
  },
}
